import PushNotificationBoxContainer from "./PushNotificationBoxContainer";

const PushNotificationCommunication = () => {
  return (
    <div className="page-body">
      <PushNotificationBoxContainer />
    </div>
  );
};

export default PushNotificationCommunication;
